export enum ExecuteStatus {
  NONE = 'NONE',
  IN_PROGRESS = 'IN_PROGRESS',
  MAX_CAPACITY = 'MAX_CAPACITY',
}
